/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import userApi from 'api/user.api';
import { createFOAsyncThunk } from '../../../helpers/thunk.helpers';

/* Thunks */
export const removeUsersFromOrg = createFOAsyncThunk('removeUsers/removeFromOrg', async (args) => {
  return userApi.removeUsersFromOrganization(args.orgId, args.userIds);
});
